import React from 'react';
import { useTranslation } from 'react-i18next';
import { IEquipmentEntry } from 'types/IEquipmentEntry';
import {
  EquipmentInfoCard,
  SubscriptionPlanCards,
} from 'app/components/subscriptions/dialogs/ManageYourPlanDialog/components';
import './BasicPlanView.less';

interface Props {
  equipment: IEquipmentEntry;
}

export default function BasicPlanView({ equipment }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <p className="basic-plan-view__subtitle">
        {t('subscriptions.manage_your_plan.basic_plan_view.subtitle')}
      </p>

      <EquipmentInfoCard
        className="basic-plan-view__eq-info-card"
        equipment={equipment}
      />

      <SubscriptionPlanCards equipment={equipment} />

      <p className="basic-plan-view__disclaimer">
        {t(
          'subscriptions.manage_your_plan.basic_plan_view.all_machine_statuses',
        )}
      </p>
    </>
  );
}
